export function getOrdinalDay() {
  const day = this.getDayNumeric();
  if (day < 1 || day > 31) {
    return 'Invalid day: ' + day;
  }

  let suffix = 'th';
  if (day === "1" || day === "21" || day === "31") {
    suffix = 'st';
  } else if (day === "2" || day === "22") {
    suffix = 'nd';
  } else if (day === "3" || day === "23") {
    suffix = 'rd';
  }
  return `${this.getDayOfWeek() + ' ' + day + suffix}`;
}

export function getDay(date) {
  const d = new Date(date || Date.now());
  return d.toLocaleString('en-US', { weekday: 'short' });
}

export function getDayNumeric(date) {
  const d = new Date(date || Date.now());
  return String(d.getDate()).padStart(2, '0');
}

export function getMonthShort(date) {
  const d = new Date(date || Date.now());
  return d.toLocaleString('en-US', { month: 'short' });
}

export function getYear(date) {
  const d = new Date(date);
  return d.getFullYear();
}

export function getCurrentMonth() {
  const d = new Date();
  return d.toLocaleString('en-US', { month: 'long', year: 'numeric' });
}

export function getDayOfWeek(date) {
  const d = new Date(date || Date.now());
  return d.toLocaleString('en-US', { weekday: 'long' });
}

export function getMonth(date) {
  const d = new Date(date || Date.now());
  return d.toLocaleString('en-US', { month: 'long' });
}

export function getNextMonth() {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth() + 1, 1)
    .toLocaleString('en-US', { month: 'long' });
  ;
}

export function niceDate(event, separator = '●') {
  return `${getDay(
    event.metadata.date + 'T' + event.metadata.start_time
  )}
      ${getMonthShort(event.metadata.date + 'T' + event.metadata.start_time)}
      ${getDayNumeric(
    event.metadata.date + 'T' + event.metadata.start_time
  )}, ${getYear(event.metadata.date)} ${separator} ${event.metadata.start_time} Hrs`;
}

export function eventPerformed(dateString) {

  // moment.utc(state.party.metadata.date).endOf('day') <=
  // moment().startOf('day')
  const partyDate = new Date(dateString);
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to 0
  partyDate.setHours(23, 59, 59, 999);
  return partyDate <= today;
}




